class CardSlider extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('recommendations:loaded', this.initSlider());
    document.addEventListener('transition:end', this.initSlider());
    document.addEventListener('DOMContentLoaded', this.initSlider());
    document.addEventListener('search-results:loaded', this.initSlider());
    document.addEventListener('product-grid:updated', function() {
      const sliders = this.querySelectorAll('.glide');

      if ( sliders ) {
        sliders.forEach((slider) => {
          if ( slider ) {
            const glide = new Glide(slider, {
              type: 'slider'
            });
  
            glide.mount();
            
            slider.addEventListener('mouseover', function () {
              glide.play(3000);
            });
      
            slider.addEventListener('mouseout', function () {
              glide.pause();
            });
          }
        });
      }
    });
  }

  initSlider() {
    const sliders = this.querySelectorAll('.glide');

    if ( sliders ) {
      sliders.forEach((slider) => {
        if ( slider ) {
          const glide = new Glide(slider, {
            type: 'slider'
          });

          glide.mount();
          
          slider.addEventListener('mouseover', function () {
            glide.play(3000);
          });
    
          slider.addEventListener('mouseout', function () {
            glide.pause();
          });
        }
      });
    }
  }
}

customElements.define('card-slider', CardSlider);
